
/**
 * 트윗 유형
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType = typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType[keyof typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
